<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-66">
        <edit-profile-form header-color="green"> </edit-profile-form>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-33">
        <user-card :cardUserImage="getUserImage()" button-color="success">
        </user-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-66">
        <password-update-form header-color="green"> </password-update-form>
      </div>
    </div>
  </div>
</template>

<script>
import { EditProfileForm, UserCard } from "@/pages";
import PasswordUpdateForm from "./UserProfile/PassUpdateForm";
export default {
  components: {
    PasswordUpdateForm,
    EditProfileForm,
    UserCard
  },
  methods: {
    getUserImage() {
      if (
        this.$store.user_picture == null ||
        this.$store.user_picture === "null"
      ) {
        return "/img/default-avatar.png";
      } else {
        return this.$store.user_picture;
      }
    }
  }
};
</script>
<style lang="scss">
.text-right {
  display: flex;
}
</style>
